import "react";

import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const calendarPrefix = "DRDPContainer";
export const calendarClasses = {
  root: `${calendarPrefix}-root`,
};

export const DRDPContainer = styled(Stack)(({ theme }) => ({
  [`&.${calendarClasses.root}`]: {
    flexDirection: "row",
    rowGap: theme.spacing(3),
    justifyContent: "space-between",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
}));

const dayItemPrefix = "DRDPDayItemContainer";
export const dayItemClasses = {
  root: `${dayItemPrefix}-root`,
  button: `${dayItemPrefix}-button`,
  divStartSelected: `${dayItemPrefix}-divStartSelected`,
  divEndSelected: `${dayItemPrefix}-divEndSelected`,
  selected: `${dayItemPrefix}-selected`,
  between: `${dayItemPrefix}-between`,
};

export const DRDPDayItemContainer = styled(Box)(({ theme }) => ({
  [`&.${dayItemClasses.root}`]: {
    height: "36px",
    width: "36px",
    maxWidth: "36px",
    minWidth: "36px",
    [`&.${dayItemClasses.between}`]: {
      backgroundColor: theme.palette.border.main,
      borderRadius: "0px",
    },
    [`&.${dayItemClasses.divStartSelected}`]: {
      backgroundColor: theme.palette.border.main,
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%",
    },
    [`&.${dayItemClasses.divEndSelected}`]: {
      backgroundColor: theme.palette.border.main,
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%",
    },
    [`& .${dayItemClasses.button}`]: {
      ...theme.typography.subtitle1,
      height: "36px",
      width: "36px",
      maxWidth: "36px",
      minWidth: "36px",
      padding: "0px",
      backgroundColor: "transparent",
      border: "unset",
      borderRadius: "50%",
      boxSizing: "border-box",
      textTransform: "capitalize",
      color: theme.palette.black.dark,
      transition: "unset",
      "&:hover": {
        cursor: "pointer",
        border: `1px solid ${theme.palette.primary.main}`,
      },
      "&:disabled": {
        color: "rgba(0, 0, 0, 0.26)",
      },
      [`&.${dayItemClasses.selected}`]: {
        backgroundColor: theme.palette.primary.main,
        color: "white",
      },
    },
  },
}));
